import { HttpMethods, makeRequest } from '../helpers/http.helper';
import type {
  Facility,
  FacilityIncomingOrdersResponse,
  FacilityInput,
  FacilityPagination,
  FacilityQuery,
  FacilityUpdateInput,
} from '../types/facility.type';

interface GenericResponse<T> {
  result: T;
}

export async function listFacilities(params: FacilityQuery): Promise<FacilityPagination> {
  const response = await makeRequest({
    url: '/ops/facilities',
    method: HttpMethods.GET,
    params,
  }) as GenericResponse<FacilityPagination>;
  return response.result;
}

export async function getFacility(organizationId: string, facilityId: string): Promise<Facility> {
  const response = await makeRequest({
    url: `/ops/facilities/${facilityId}`,
    method: HttpMethods.GET,
    params: { organization_id: organizationId },
  }) as GenericResponse<Facility>;
  return response.result;
}

export async function createFacility(organizationId: string, input: FacilityInput): Promise<Facility> {
  const response = await makeRequest({
    url: '/ops/facilities',
    method: HttpMethods.POST,
    params: { organization_id: organizationId },
    data: input,
  }) as GenericResponse<Facility>;
  return response.result;
}

export async function updateFacility(
  organizationId: string,
  facilityId: string,
  input: FacilityUpdateInput,
): Promise<Facility> {
  const response = await makeRequest({
    url: `/ops/facilities/${facilityId}`,
    method: HttpMethods.PATCH,
    params: { organization_id: organizationId },
    data: input,
  }) as GenericResponse<Facility>;
  return response.result;
}

export async function archiveFacility(organizationId: string, facilityId: string): Promise<void> {
  await makeRequest({
    url: `/ops/facilities/${facilityId}`,
    method: HttpMethods.DELETE,
    params: { organization_id: organizationId },
  });
}

export async function getFacilityIncomingOrders(
  organizationId: string,
  facilityId: string,
  params: { page?: number; limit?: number } = {},
): Promise<FacilityIncomingOrdersResponse> {
  const response = await makeRequest({
    url: `/ops/facilities/${facilityId}/incoming-orders`,
    method: HttpMethods.GET,
    params: { organization_id: organizationId, ...params },
  }) as GenericResponse<FacilityIncomingOrdersResponse>;
  return response.result;
}
